module.exports = __webpack_public_path__ + "img/ferris-wheel.b50bf285.svg";